import React, { memo, MouseEvent } from 'react'
import { useHistory } from 'react-router'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Button } from 'transfix-ui/components/Button/Button'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics'
import { BidResponse } from 'apps/fleet-planner/types/apiTypes'

interface IBidActionProps {
  bid: BidResponse
  dataTest?: string
  onClick: () => void
}

const useBidsActionStyles = makeStyles(() => ({
  coolGray5: {
    color: brandColors.coolGray5,
  },
}))

export const BidAction = memo<IBidActionProps>(({ bid, dataTest, onClick }) => {
  const { trackEvent } = useFMSAnalytics()
  const { setActiveShipmentDetailsId } = useMarketplaceContext()
  const { shipment, status: bidStatus } = bid || {}
  const { id, state: shipmentStatus } = shipment || {}
  const history = useHistory()
  const classes = useBidsActionStyles()
  const bidAgainHandler = (event: MouseEvent<HTMLButtonElement>) => {
    onClick()
    event.stopPropagation()
    trackEvent('Bids Page', 'DECLINED_CLICKED_BID_AGAIN', { bid })
    history.push(`/bids/${id}/bid/`)
    setActiveShipmentDetailsId(id)
  }
  const editBidHandler = () => {
    onClick()
    trackEvent('Bids Page', 'PENDING_CLICKED_EDIT_BID', { bid })
    history.push(`/bids/${id}`)
    setActiveShipmentDetailsId(id)
  }
  const bookShipmentHandler = (event: MouseEvent<HTMLButtonElement>) => {
    onClick()
    event.stopPropagation()
    trackEvent('Bids Page', 'ACCEPTED_CLICKED_BOOK_NOW', { bid })
    history.push(`book/${id}/rate-confirmation`)
  }
  return (
    <Box display='flex' alignItems='center' justifyContent='flex-end'>
      {(bidStatus === 'accepted' && (
        <Button data-test={`${dataTest}-book-now`} onClick={bookShipmentHandler} color='primary'>
          Accept Offer
        </Button>
      )) ||
        (['countered', 'pending'].includes(bidStatus) && (
          <IconButton
            data-test={`${dataTest}-edit-bid`}
            color='tertiary'
            Icon={EditIcon}
            onClick={editBidHandler}
            label='Edit Bid'
            size='large'
          />
        )) ||
        (bidStatus === 'declined' && shipmentStatus === 'pending' && (
          <Button data-test={`${dataTest}-bid-again`} onClick={bidAgainHandler} color='secondary'>
            Bid Again
          </Button>
        )) || (
          <Typography
            data-test={`${dataTest}-load-unavailable`}
            className={classes.coolGray5}
            variant='subtitle2'>
            Load Unavailable
          </Typography>
        )}
    </Box>
  )
})
